// Create an object that contains all data and setter functions that are needed
// to render a ProductCard for the selected option and layout.
import { getPriceDetailsUtil } from 'data-hooks/utils';

const mergeProductAndSelectedOptionData = ({
  campaign,
  id,
  isClearance,
  moreVariantsCount,
  name,
  onDisplayInShowroomSlug,
  path: productPath,
  productFamily,
  productLabel,
  quickship,
  secondaryImage,
  secondaryImageCropData,
  selectedOption,
  slug,
  variantsToShow,
  variantsTotal,
  meta,
  bypass_stock,
}) => {
  // Extract all required data from the selected option
  const {
    image,
    isOutOfStock,
    label,
    otherAttributes,
    minPrice,
    originalPrice,
    path,
    price,
    sku,
    thumbnail,
  } = selectedOption ?? {};

  let finalPrice = price;
  let finalMinPrice = minPrice;

  const promotion = meta?.promotion;
  if (isClearance && promotion?.active && promotion?.tiers?.length > 0) {
    const priceObj = {
      original_price: originalPrice || price,
      final_price: price,
      discount_percent: 0,
    };

    const priceDetails = getPriceDetailsUtil(priceObj, promotion, 0, true);

    if (priceDetails.hasTieredDiscount) {
      finalMinPrice = priceDetails.maxTieredDiscountedPrice;
      finalPrice = priceDetails.leastTieredDiscountedPrice;
    }
  }

  // Merge product data and selected option data into a single object
  const productCardData = {
    campaign,
    id,
    image,
    isOutOfStock,
    label,
    moreVariantsCount,
    name,
    onDisplayInShowroomSlug,
    minPrice: finalMinPrice,
    originalPrice,
    otherAttributes,
    path,
    price: finalPrice,
    productFamily,
    productLabel,
    productPath,
    quickship,
    secondaryImage,
    secondaryImageCropData,
    sku,
    slug,
    upholsteryThumbnail: thumbnail,
    variantsToShow:
      variantsToShow?.map(variant => ({
        ...variant,
        isSelected:
          variant?.id &&
          selectedOption?.id &&
          variant?.id === selectedOption?.id,
      })) ?? [],
    variantsTotal,
    bypass_stock,
  };

  return productCardData;
};

export default mergeProductAndSelectedOptionData;
